export const GoogleAppLink =
  "https://play.google.com/store/apps/details?id=com.whitelion.whitelionhome&pli=1";
export const AppleAppLink =
  "https://apps.apple.com/al/app/airhome-lifestyle-automation/id6479554375";
export const WhatsAppMsg =
  "Hi, can you share details about Whitelion products? I visited your website.";
